export default __webpack_public_path__ + "static/media/background_white_graphics_square_right_01.0d52e1f7.png";